import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import NavDropdown from './NavDropdown';

function monogramOf(userProfile, user) {
    const source = userProfile?.name || user?.email || '?';
    return source.trim().charAt(0).toUpperCase();
}

function roleLabel(isAdmin, isFacilityAdmin) {
    if (isFacilityAdmin) return 'facility_admin';
    if (isAdmin) return 'site_admin';
    return 'case_manager';
}

export default function AvatarMenu() {
    const { user, userProfile, isAdmin, isFacilityAdmin, signOut } = useAuth();

    const monogram = monogramOf(userProfile, user);
    const name = userProfile?.name || user?.email || 'Account';
    const email = user?.email || '';
    const primaryRole = roleLabel(isAdmin, isFacilityAdmin);

    return (
        <NavDropdown
            trigger={
                <button type="button" className="avatar-button" aria-label="Account menu">
                    {monogram}
                </button>
            }
            panelClassName="avatar-panel"
            aria-label="Account menu"
        >
            <div className="avatar-header">
                <div className="avatar-name">{name}</div>
                <div className="avatar-email">{email}</div>
                <div className="avatar-chips">
                    <span className="role-chip">{primaryRole}</span>
                    {isAdmin && <span className="role-chip role-chip-staff">staff</span>}
                </div>
            </div>
            <Link to="/profile" className="nav-dropdown-item" role="menuitem">Profile</Link>
            {(isFacilityAdmin || isAdmin) && (
                <Link to="/billing" className="nav-dropdown-item" role="menuitem">Billing</Link>
            )}
            <Link to="/help" className="nav-dropdown-item" role="menuitem">Help</Link>
            <div className="nav-dropdown-divider" />
            <button
                type="button"
                className="nav-dropdown-item nav-dropdown-action"
                role="menuitem"
                onClick={() => signOut()}
            >
                Logout
            </button>
        </NavDropdown>
    );
}
